import React from 'react';
import Header from '../components/header';
import DividerBottom from '../components/divider-bottom';
import Footer from '../components/footer';

import ParentsGuideToBeavers from "../assets/files/Parents guide to Beavers.pdf";
import ParentsGuideToCubs from "../assets/files/Parents guide to Cubs.pdf";
import ParentsGuideToScouts from "../assets/files/Parents guide to Scouts.pdf";
import CampKitList from "../assets/files/Camp kit-list.docx";
import InTouchForm from "../assets/files/In Touch or Home Contact form.docx";
import RegularMedicationForm from "../assets/files/Regular medication form.docx";
import YoungPersonForm from "../assets/files/Young person form.pdf";
import BCShootingDeclarationForm from "../assets/files/BC shooting declaration form.pdf";
import AccidentRecordSheet from "../assets/files/Accident record sheet.docx";

function Files() {
    return (
        <>
            <Header />

            <main>
                <section id="files">
                    <h1>Useful Forms</h1>
                    <div className="files-container">
                        <a href={ParentsGuideToBeavers} target="_blank" className="file">
                            <i className="fa fa-file-pdf-o file-icon"></i>
                            <h3>Parents guide to Beavers</h3>
                            <p>Information for parents of Beavers.</p>
                        </a>
                        <a href={ParentsGuideToCubs} target="_blank" className="file">
                            <i className="fa fa-file-pdf-o file-icon"></i>
                            <h3>Parents guide to Cubs</h3>
                            <p>Information for parents of Cubs.</p>
                        </a>
                        <a href={ParentsGuideToScouts} target="_blank" className="file">
                            <i className="fa fa-file-pdf-o file-icon"></i>
                            <h3>Parents guide to Scouts</h3>
                            <p>Information for parents of Scouts.</p>
                        </a>
                        <a href={CampKitList} target="_blank" className="file">
                            <i className="fa fa-file-word-o file-icon"></i>
                            <h3>Camp kit-list</h3>
                            <p>A simple kit-list for all camp goers.</p>
                        </a>
                        <a href={InTouchForm} target="_blank" className="file">
                            <i className="fa fa-file-word-o file-icon"></i>
                            <h3>In touch form</h3>
                            <p>For parents to fill out to provide contact details for camp.</p>
                        </a>
                        <a href={RegularMedicationForm} target="_blank" className="file">
                            <i className="fa fa-file-word-o file-icon"></i>
                            <h3>Regular medication form</h3>
                            <p>This form is to be filled out and brought to camp with your child.</p>
                        </a>
                        <a href={YoungPersonForm} target="_blank" className="file">
                            <i className="fa fa-file-pdf-o file-icon"></i>
                            <h3>Young person information form</h3>
                            <p>For parents to fill out for any new child joining our group.</p>
                        </a>
                        <a href={BCShootingDeclarationForm} target="_blank" className="file">
                            <i className="fa fa-file-pdf-o file-icon"></i>
                            <h3>BC shooting declaration form</h3>
                            <p>Permission form for shooting at BC. Requires a physical signature (not digital).</p>
                        </a>
                        <a href={AccidentRecordSheet} target="_blank" className="file">
                            <i className="fa fa-file-word-o file-icon"></i>
                            <h3>Accident record sheet</h3>
                            <p>This is for leaders to fill out in the event of an accident.</p>
                        </a>
                    </div>
                </section>
                <DividerBottom />
            </main>
            <Footer />
        </>
    );
}

export default Files;